<p-inputNumber
  [(ngModel)]="numVal"
  class="form-control form-control-sm"
  [disabled]="disableField"
  mode="decimal"
  [attr.id]="element.name"
  (onInput)="valueChange($event)"
  (onBlur)="utilService.flushDebounce(debounceValChanges)"
  maxlength="16"
  [minFractionDigits]="formData.f_minFrac"
  [maxFractionDigits]="formData.f_maxFrac"
></p-inputNumber>
